<template>
  <div class="box1" >
        <div class="bottomBox">
          <div class="img3">
            <img v-if="item.rytx" :src="item.rytx" alt="" style="width: 100%; height: 100%;cursor: pointer" @click="goDetails">
            <div v-else style="width: 100%; height: 100%;cursor: pointer;border: 1px solid lightgrey"></div>
          </div>
          <div class="month">
            <div class="span_month">获奖月份</div>
            <div class="span_month2">{{item && item.zq ? item.zq : ''}}</div>
          </div>
          <div class="personnel">
            <div class="span_personnel">获奖战队</div>
            <div class="span_month2">{{item && item.deptName ? item.deptName : ''}}</div>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  created() {
  },
  methods: {
    goDetails() {
      this.$router.push({
        name: '心得体会',
        params: {
          xdItem: this.item
        }
      })
    },
  }
};
</script>

<style scoped="scoped" lang="scss">
    .box1 {
      display: inline-block;
      width: 100%;
      //height: 257px;
      background-color: rgba(255, 255, 255, 0.5);
      .bottomBox {
        position: relative;

        .month {
          position: absolute;
          top: -28px;
          left: 280px;
          float: left;
          height: 50%;
          margin-top: 50px;
          .span_month2 {
            color: #2d8cf0;
            font-size: 20px;
            font-weight: 600;
          }
        }

        .personnel {
          position: absolute;
          top: 116px;
          left: 280px;
          float: left;
          height: 50%;
          .span_month2 {
            color: #2d8cf0;
            font-size: 20px;
            font-weight: 600;
          }
        }

        .img3 {
          display: inline-block;
          width: 195px;
          height: 230px;
          margin-left: 30px;
        }

        .span_month {
          display: inline-block;
          width: 100%;
        }

        .span_personnel {

        }

      }
    }
</style>
